import { render } from "./MGWalkthrough.vue?vue&type=template&id=bb40b2a0&scoped=true"
import script from "./MGWalkthrough.vue?vue&type=script&lang=js"
export * from "./MGWalkthrough.vue?vue&type=script&lang=js"

import "./MGWalkthrough.vue?vue&type=style&index=0&id=bb40b2a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb40b2a0"]])

export default __exports__